import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Table, Button, Icon, Row, Col, Input, message, Upload } from "antd";
import _ from "lodash";
import { on, get } from "../../utils/sockets";
import {
  getModelName,
  getAttributes,
  getAttributeAssociation
} from "../../utils/models";
import ActionButtons from "../ActionButtons";
import Format from "../Format";
import ShowModal from "../ShowModal";
import HasPermission from "../HasPermission";
import config from "../../config/custom";
import { FormattedMessage } from "react-intl";
import { request } from "../../utils/sockets";
import { request as httpRequest } from '../../utils/http';
import custom from "../../config/custom";

import "./index.css";

const columnsProfit = [
  {
    title: <FormattedMessage id={`Attribute.profits.material`} />,
    dataIndex: "material",
    key: "material"
  },
  {
    title: <FormattedMessage id={`Attribute.profits.compra`} />,
    children: [
      {
        title: <FormattedMessage id={`Attribute.profits.proveedor`} />,
        dataIndex: "proveedor",
        key: "proveedor",
        className: "proveedorLine"
      },
      {
        title: <FormattedMessage id={`Attribute.profits.montoCompra`} />,
        dataIndex: "montoCompra",
        key: "montoCompra"
      },
      {
        title: <FormattedMessage id={`Attribute.profits.divisaCompra`} />,
        dataIndex: "divisaCompra",
        key: "divisaCompra"
      },
      {
        title: <FormattedMessage id={`Attribute.profits.folioCompra`} />,
        dataIndex: "folioCompra",
        key: "folioCompra"
      }
    ]
  },
  {
    title: <FormattedMessage id={`Attribute.profits.ventas`} />,
    children: [
      {
        title: <FormattedMessage id={`Attribute.profits.customerId`} />,
        dataIndex: "customerId",
        key: "customerId",
        className: "proveedorLine"
      },
      {
        title: <FormattedMessage id={`Attribute.profits.ventana`} />,
        dataIndex: "montoVenta",
        key: "montoVenta"
      },
      {
        title: <FormattedMessage id={`Attribute.profits.divisaVenta`} />,
        dataIndex: "divisaVenta",
        key: "divisaVenta"
      },
      {
        title: <FormattedMessage id={`Attribute.profits.folioVenta`} />,
        dataIndex: "folioVenta",
        key: "folioVenta"
      }
    ]
  }
];

const columns = [
  // {
  //     title: <FormattedMessage id={'Attribute.id'} />,
  //     dataIndex: 'id',
  //     key: 'id',
  // },
  // {
  //     title: <FormattedMessage id={'Attribute.createdAt'} />,
  //     dataIndex: 'createdAt',
  //     key: 'createdAt',
  // },
  // {
  //     title: <FormattedMessage id={'Attribute.updatedAt'} />,
  //     dataIndex: 'updatedAt',
  //     key: 'updatedAt',
  // }
];

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      total: undefined,
      page: 1,
      pageSize: props.hasOwnProperty("belongsTo") ? 100 : 10,
      items: [],
      columns,
      loading: true,
      syncLoading: false
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.init();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.model !== this.props.model) {
      this.init();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.query !== this.state.query) {
      this.setState({ page: 1 }, () => {
        this.search();
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  init() {
    this.setState(
      {
        query: "",
        total: undefined,
        page: 1,
        items: []
      },
      () => {
        this.setColumns();
      }
    );

    setImmediate(() => {
      this.getItems();
    });

    on(this.props.model, msg => {
      if (this.mounted) {
        if (msg.verb === "created") {
          const association = this.props.belongsTo
            ? this.props.belongsTo.association
            : null;
          const associationId = this.props.belongsTo
            ? this.props.belongsTo.id
            : null;

          if (
            !this.props.hasOwnProperty("belongsTo") ||
            (msg.data[association] &&
              msg.data[association].id === associationId)
          ) {
            this.add(msg.data);
          }
        }

        if (msg.verb === "updated") {
          this.update(msg.data);
        }

        if (msg.verb === "destroyed") {
          this.remove(msg.id);
        }

        message.success(`${_.startCase(this.props.model)} ${msg.verb}`);
      }
    });
  }

  displayAdapter(items) {
    items =
      this.props.model === "vehicle" ? _.filter(items, o => o.active) : items;

    return _.map(items, row => {
      return _.mapValues(row, (val, key) => {
        if (key === "id") {
          return val;
        }

        return <Format model={this.props.model} attribute={key} value={val} />;
      });
    });
  }

  getUrl() {
    let url;

    if (this.props.hasOwnProperty("belongsTo")) {
      const model = getModelName(
        this.props.model,
        this.props.belongsTo.association
      );
      const association = getAttributeAssociation(
        this.props.model,
        this.props.belongsTo.association
      );

      url = `${config.baseUrl}/${model}/${
        this.props.belongsTo.id
      }/${association}`;
    } else {
      url = `${config.baseUrl}/paginate/${this.props.model}`;
    }

    return url;
  }

  getItems() {
    if (this.props.hasOwnProperty("belongsTo")) {
      this.setState({ loading: true });

      // this.setState({
      //   items: this.displayAdapter(values)
      // });
      get(this.getUrl())
        .then(response => {
          this.setState({
            items: this.displayAdapter(response)
          });
        })
        .catch(() => {
          //
        })
        .then(() => {
          this.setState({ loading: false });
        });
    } else {
      this.search();
    }
  }

  setColumns() {
    if (this.props.model === "profitandloses") {
      let extraColumns = [];
      extraColumns.push({
        title: <FormattedMessage id={"List.action"} />,
        dataIndex: "action",
        key: "action",
        width: this.props.disabled ? 70 : 200,
        render: (text, record) => (
          <ActionButtons {...this.props} id={record.id} />
        )
      });
      this.setState({ columns: [...columnsProfit, ...extraColumns] });
    } else {
      const attributes = getAttributes(this.props.model);
      let extraColumns = [];
      if (attributes) {
        _.keys(attributes).forEach(key => {
          if (!attributes[key].hasOwnProperty("collection")) {
            extraColumns.push({
              title: (
                <FormattedMessage id={`Attribute.${this.props.model}.${key}`} />
              ),
              dataIndex: key,
              key,
              className: "tablecolumns"
            });
          }
        });

        extraColumns.push({
          title: <FormattedMessage id={"List.action"} />,
          dataIndex: "action",
          key: "action",
          fixed: "right",
          width: this.props.disabled ? 70 : 200,
          render: (text, record) => (
            <ActionButtons
              {...this.props}
              id={record.id}
              disableDelete={this.props.model === "vehicletype"}
            />
          )
        });
      }

      this.setState({ columns: [...columns, ...extraColumns] });
    }
  }

  add(data) {
    if (_.findIndex(this.state.items, { id: data.id }) === -1) {
      this.setState({
        total: this.state.total + 1,
        items: [...this.displayAdapter([data]), ...this.state.items]
      });
    }
  }

  update(data) {
    let items = [...this.state.items];
    const index = _.findIndex(items, { id: data.id });

    data = this.displayAdapter([data])[0];

    if (index !== -1) {
      items.splice(index, 1, { ...items[index], ...data });
    }

    this.setState({ items });
  }

  remove(id) {
    let items = [...this.state.items];
    const index = _.findIndex(items, { id });

    if (index !== -1) {
      items.splice(index, 1);
    }

    this.setState({ items });
  }

  search = _.debounce(async () => {
    this.setState({ loading: true });

    try {
      await request(`${custom.baseUrl}/${this.props.model}?limit=0`);

      const response = await request(
        `${custom.baseUrl}/pagination/${this.props.model}`,
        {
          data: {
            query: this.state.query,
            page: this.state.page,
            pageSize: this.state.pageSize
          }
        }
      );

      this.setState({
        items: this.displayAdapter(response.items),
        total: response.total
      });
    } catch (error) {
      //
    }

    this.setState({ loading: false });
  }, 500);

  render() {
    const props = _.pick(this.props, [
      "model",
      "belongsTo",
      "props",
      "customerId",
      "options",
      "values",
      "quote"
    ]);

    const allowedModels = [
      "medicalexam",
      "quote",
      "local",
      "maritime",
      "land",
      "aamx",
      "containers"
    ];

    const uploadProps = {
      name: 'file',
      accept: '.csv',
      showUploadList: false,
      customRequest: async (r) => {
        const formData = new FormData();
        formData.append('files', r.file);
        const fileList = await httpRequest(`${custom.baseUrl}/files`, {
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((r) => r.data.fileList)

        const drivers = await httpRequest(
          `${custom.baseUrl}/driver/massive`, {
            method: 'post',
            data: {
              files: fileList[0]
            },
          }
        ).then((r) => r.data)

        if (drivers.success) {
          message.success('Conductores creados');
        } else {
          message.error('Ha ocurrido un error al crear los conductores');
        }
      },
    };

    return (
      <Fragment>
        <div
          style={
            this.props.hasOwnProperty("belongsTo")
              ? {}
              : {
                  position: "absolute",
                  top: -100,
                  right: 15,
                  width: this.props.model === "driver" ? "800px" : "500px"
                }
          }
        >
          <Row gutter={10}>
            {!this.props.hasOwnProperty("belongsTo") && (
              <Col span={14}>
                <Input
                  value={this.state.query}
                  onChange={e => {
                    this.setState({ query: e.target.value });
                  }}
                  prefix={<Icon type={"search"} />}
                />
              </Col>
            )}
            {this.props.model === "vehicletype" && (
              <HasPermission name={"Crear"}>
                <Col span={10}>
                  <Button
                    style={
                      this.props.hasOwnProperty("belongsTo")
                        ? { marginBottom: 10, width: "100%" }
                        : { width: "100%" }
                    }
                    type={
                      this.props.hasOwnProperty("belongsTo")
                        ? "dashed"
                        : "primary"
                    }
                    disabled={this.state.syncLoading}
                    onClick={() => {
                      this.setState({ syncLoading: true });
                      request(`${config.baseUrl}/${this.props.model}/sap`, {
                        method: "put"
                      })
                        .then(() => {
                          message.success("Sincronización completa");
                        })
                        .catch(() => {
                          message.error("Sincronización no exitosa");
                        })
                        .finally(() => {
                          this.setState({ syncLoading: false });
                          this.init();
                        });
                    }}
                  >
                    <Icon type="sync" />
                    <FormattedMessage id="Sincronizar" />
                  </Button>
                </Col>
              </HasPermission>
            )}
            {this.props.model === "driver" && (
              <HasPermission name={"Crear"}>
                <Col span={this.props.model === "driver" ? 5 : 10}>
                  <Upload
                    {...uploadProps}
                    style={{ width: '100%' }}
                  >
                    <Button style={{ width: '100%' }}>
                      <Icon type="upload" /> Carga Masiva
                    </Button>
                  </Upload>
                </Col>
              </HasPermission>
            )}
            {(this.props.showAdd ||
              _.includes(allowedModels, this.props.model)) &&
              !this.props.disabled && (
                <HasPermission name={"Crear"}>
                  <ShowModal type="form" {...props} init={() => this.init()}>
                    <Col span={this.props.model === "driver" ? 5 : 10}>
                      <Button
                        style={
                          this.props.hasOwnProperty("belongsTo")
                            ? { marginBottom: 10, width: "100%" }
                            : { width: "100%" }
                        }
                        type={
                          this.props.hasOwnProperty("belongsTo")
                            ? "dashed"
                            : "primary"
                        }
                      >
                        <Icon type="plus" />
                        <FormattedMessage
                          id={`Model.${this.props.model}.add`}
                        />
                      </Button>
                    </Col>
                  </ShowModal>
                </HasPermission>
              )}
          </Row>
        </div>

        {this.props.model === "quote" && (
          <Table
            dataSource={this.state.items}
            columns={this.state.columns}
            scroll={{ x: 700 }}
            loading={this.state.loading}
            rowClassName={(record, index) => {
              if (record.status.props.value === "ACEPTADO") {
                return "table-green border";
              } else if (record.status.props.value === "RECHAZADO") {
                return "table-red border";
              } else {
                return "table-white border";
              }
            }}
            pagination={
              !this.props.hasOwnProperty("belongsTo") && {
                defaultCurrent: 1,
                current: this.state.page,
                pageSize: this.state.pageSize,
                total: this.state.total,
                showSizeChanger: true,
                onChange: page => {
                  this.setState({ page }, () => {
                    this.search();
                  });
                },
                onShowSizeChange: (page, pageSize) => {
                  this.setState({ page, pageSize }, () => {
                    this.search();
                  });
                }
              }
            }
            rowKey="id"
          />
        )}

        {this.props.model === "profitandloses" && (
          <Table
            dataSource={this.state.items}
            columns={this.state.columns}
            scroll={{ x: 700 }}
            bordered
            loading={this.state.loading}
            footer={pageData => {
              let totalCompra = 0;
              let totalVenta = 0;
              pageData.forEach(
                ({ montoCompra, montoVenta, exchangeRate, divisaCompra }) => {
                  if (divisaCompra.props.value === "MXN") {
                    totalCompra =
                      totalCompra +
                      montoCompra.props.value / exchangeRate.props.value;
                    totalVenta += montoVenta.props.value;
                  } else {
                    totalCompra += montoCompra.props.value;
                    totalVenta += montoVenta.props.value;
                  }
                }
              );
              let totalFinal = totalVenta - totalCompra;
              let message = "";
              let color = "";
              if (totalFinal < 0) {
                message = "Perdida";
                color = "rgba(243, 69, 55, 0.8)";
              } else {
                message = "Ganancia";
                color = "rgba(23, 255, 0, 0.4)";
              }
              return (
                <table>
                  <tr>
                    <td className="totalsTable">
                      <b>Total</b>
                    </td>
                    <td className="totalsTable">
                      <b>Compra: </b> ${totalCompra.toFixed(2)}
                    </td>
                    <td className="totalsTable">
                      <b>Venta: </b>${totalVenta.toFixed(2)}
                    </td>
                    <td
                      className="totalsTable"
                      style={{ border: `1px solid ${color}` }}
                    >
                      <b>{message} </b>${totalFinal.toFixed(2)}
                    </td>
                  </tr>
                </table>
              );
            }}
            pagination={
              !this.props.hasOwnProperty("belongsTo") && {
                defaultCurrent: 1,
                current: this.state.page,
                pageSize: this.state.pageSize,
                total: this.state.total,
                showSizeChanger: true,
                onChange: page => {
                  this.setState({ page }, () => {
                    this.search();
                  });
                },
                onShowSizeChange: (page, pageSize) => {
                  this.setState({ page, pageSize }, () => {
                    this.search();
                  });
                }
              }
            }
            rowKey="id"
          />
        )}

        {this.props.model !== "quote" && this.props.model !== "profitandloses" && (
          <Table
            dataSource={this.state.items}
            columns={this.state.columns}
            scroll={{ x: true }}
            loading={this.state.loading}
            pagination={
              !this.props.hasOwnProperty("belongsTo") && {
                defaultCurrent: 1,
                current: this.state.page,
                pageSize: this.state.pageSize,
                total: this.state.total,
                showSizeChanger: true,
                onChange: page => {
                  this.setState({ page }, () => {
                    this.search();
                  });
                },
                onShowSizeChange: (page, pageSize) => {
                  this.setState({ page, pageSize }, () => {
                    this.search();
                  });
                }
              }
            }
            rowKey="id"
          />
        )}
      </Fragment>
    );
  }
}

List.propTypes = {
  model: PropTypes.string.isRequired,
  belongsTo: PropTypes.object,
  inputProps: PropTypes.object,
  showAdd: PropTypes.bool
};

export default List;



// WEBPACK FOOTER //
// ./src/containers/List/index.js